import { DefaultContext, EventObject, MachineConfig, StateSchema } from 'xstate/es';

import { UserForgotPasswordStatechartEvent } from 'common/module/user/forgot-password/statechart.event';
import { UserForgotPasswordStatechartActionEnum } from 'common/module/user/forgot-password/statechart/action.enum';
import { UserForgotPasswordStatechartStateEnum } from 'common/module/user/forgot-password/statechart/state.enum';

export const UserForgotPasswordStatechart: MachineConfig<DefaultContext, StateSchema, EventObject> = {
  initial: UserForgotPasswordStatechartStateEnum.idle,
  on: {
    [UserForgotPasswordStatechartEvent.reset]: UserForgotPasswordStatechartStateEnum.idle,
  },
  states: {
    [UserForgotPasswordStatechartStateEnum.idle]: {
      on: {
        [UserForgotPasswordStatechartEvent.wantToResetPassword]: UserForgotPasswordStatechartStateEnum.validating,
      },
    },
    [UserForgotPasswordStatechartStateEnum.validating]: {
      onEntry: [UserForgotPasswordStatechartActionEnum.validateInput],
      on: {
        [UserForgotPasswordStatechartEvent.inputIsValid]: UserForgotPasswordStatechartStateEnum.executingCaptcha,
        [UserForgotPasswordStatechartEvent.inputIsNotValid]: UserForgotPasswordStatechartStateEnum.idle,
      },
    },
    [UserForgotPasswordStatechartStateEnum.executingCaptcha]: {
      onEntry: [
        UserForgotPasswordStatechartActionEnum.showLoader,
        UserForgotPasswordStatechartActionEnum.executeCaptcha,
      ],
      on: {
        [UserForgotPasswordStatechartEvent.captchaValueChanged]: UserForgotPasswordStatechartStateEnum.resetting,
      },
    },
    [UserForgotPasswordStatechartStateEnum.resetting]: {
      onEntry: [UserForgotPasswordStatechartActionEnum.resetPassword],
      on: {
        [UserForgotPasswordStatechartEvent.resetPasswordFailed]: UserForgotPasswordStatechartStateEnum.idle,
        [UserForgotPasswordStatechartEvent.resetPasswordSucceeded]: UserForgotPasswordStatechartStateEnum.idle,
      },
    },
  },
};
